export const GET_FREE_GIFT_DATA_START = 'GET_FREE_GIFT_DATA_START';

export const GET_FREE_GIFT_DATA_SUCCESS = 'GET_FREE_GIFT_DATA_SUCCESS';

export const GET_FREE_GIFT_DATA_FAILED = 'GET_FREE_GIFT_DATA_FAILED';

export const SET_FREE_GIFT_DATA_NULL = 'SET_FREE_GIFT_DATA_NULL';
